import React from 'react';

import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';

import { ArrowRightCircle } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

const ERROR_CLASS_NAME = 'has-error';

const AccordionV2Styled = styled('div')`
  & > div:first-child {
    border-top: 0 !important;
    border-radius: 8px;
  }
  & > div:first-child > div:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  & > div:last-child {
    border-top: 0 !important;
    border-radius: 8px;
  }
  & > div:last-child > div:first-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .${ERROR_CLASS_NAME} + div {
    border-top: 0;
  }
`;

export const AccordionV2 = ({ children, openPanelIndex = null }) => (
  <AccordionV2Styled>
    {React.Children.map(children, (child, index) => {
      if (openPanelIndex !== null) {
        return React.cloneElement(child, { expanded: openPanelIndex === index });
      }
      return React.cloneElement(child, { defaultExpanded: true });
    })}
  </AccordionV2Styled>
);

const AccordionItemStyled = styled(Accordion, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(
  ({ theme, ...props }) => `
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);

  .MuiAccordionSummary-content {
    max-width: 100%;

    margin: 0;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    flex-grow: 1;
    padding: 0 16px;
  }

  &.MuiAccordion-root.Mui-expanded {
    margin: 0;
  }

  &.MuiAccordion-root {
    box-shadow: none;
  }
  border-top: 1px solid ${({ theme }) => theme.colors.border.CFD7DF};

  border: 0;
  border-top: 1px solid ${props.isError ? theme.colors.feedback.FFE1D9 : theme.colors.neutral.CFD7DF};
  border-bottom: ${props.isError ? '1px' : '0'} solid ${theme.colors.feedback.FFE1D9};
  border-left: ${props.isError ? '2px' : '0'} solid ${theme.colors.alerts.negative};
`
);

export const AccordionItemV2 = ({ isError = false, ...props }) => (
  <AccordionItemStyled
    {...props}
    isError={isError}
    className={isError ? (props.className ?? '') + ERROR_CLASS_NAME : (props.className ?? '')}
  />
);

export const AccordionPanelV2 = styled(AccordionDetails)`
  padding: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.CFD7DF};
`;

const StyledAccordionButton = styled(AccordionSummary, {
  shouldForwardProp: (prop) => !['isError'].includes(prop),
})(
  ({ theme, ...props }) => `
  // border-radius: 8px;
  background: ${theme.colors.surface.F5F7F9};
  min-height: 60px;
  &.MuiAccordionSummary-root.Mui-expanded {
    min-height: 60px !important;
    
  }
  &:hover {
    background: transparent;
  }
  border-top: ${props.isError ? '1px' : '0'} solid ${theme.colors.feedback.FFE1D9};
  padding: 0 16px;
  transform: rotate(0deg);
  svg.toggle-svg {
    transition: transform 100ms;
  }
  &[aria-expanded='true'] {
    svg.toggle-svg {
      transform: rotate(90deg);
    }
    background: white;
  }
  margin: 0!important;
  display: flex;
  align-items: center;

  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  p{
    user-select: text;
  }
`
);

export const AccordionButtonV2 = ({ children, ...props }) => (
  <StyledAccordionButton {...props}>
    <Box display="flex" alignItems="center" flexGrow={1} minW={0} paddingTop={isMobileView() ? '8px' : '0px'}>
      <ArrowRightCircle className="toggle-svg" mr="12px" fill="transparent" boxSize="16px" color="primary.1565BC" />
      {children}
    </Box>
  </StyledAccordionButton>
);
